const consultation = {
  // HeroSection
  'consultation.hero.title': '個別相談予約',
  'consultation.hero.lead': 'コース選びや受講のご不安は、無料の個別相談でお気軽にご相談ください。オンラインでも来校でも承ります。執事になるにはどう進めばよいか、日本で執事を学ぶための執事学校の選び方まで、丁寧にお答えします。',
  'consultation.hero.homeLink': 'ホーム',
  'consultation.hero.admissionLink': '入学案内',
  'consultation.hero.currentPage': '個別相談予約',
  'consultation.hero.imgAlt': '落ち着いた雰囲気の個別相談スペースで相談に応じる講師',

  // breadcrumb
  'consultation.breadcrumb.home': 'ホーム',
  'consultation.breadcrumb.admission': '入学案内',
  'consultation.breadcrumb.current': '個別相談予約',

  // ConsultationFeatures
  'consultation.features.label': 'WHAT WE OFFER',
  'consultation.features.title': '個別相談でできること',
  'consultation.features.titleEn': 'What You Can Discuss',
  'consultation.features.lead': 'コース選びから料金、キャリアのご相談まで、個別相談では何でもお尋ねいただけます。オンライン（ビデオ通話）でも来校でも、ご都合のよい方法をお選びください。日本の執事学校としての学び方や入学の流れも、個別相談でご案内します。',
  'consultation.features.freeNote': '個別相談は無料です。お申込みを強制するものではございませんので、どうぞお気軽にご利用ください。',

  // ConsultationFeatures items
  'consultation.features.item.0.title': 'コース選びの相談',
  'consultation.features.item.0.desc': 'エッセンシャル・アドバンス・マスターの3コースから、ご経験や目標に合った最適なコースをご提案します。',
  'consultation.features.item.1.title': 'カリキュラム・料金の説明',
  'consultation.features.item.1.desc': '各コースの学習内容や一日の流れ、受講料の内訳まで、詳しくご説明します。ご不明点は何でもお尋ねください。',
  'consultation.features.item.2.title': 'キャリアの相談',
  'consultation.features.item.2.desc': '修了後のキャリアパスや、執事としての働き方について、業界の動向を踏まえてアドバイスいたします。',
  'consultation.features.item.3.title': '見学の手配',
  'consultation.features.item.3.desc': '実際の教室や実習スタジオをご見学いただけます。施設の雰囲気を直接ご体感ください。',

  // ConsultationForm method options
  'consultation.form.method.online.label': 'オンライン（ビデオ通話）',
  'consultation.form.method.online.desc': 'ご自宅からご参加いただけます。使用ツールはご予約後にご案内します。',
  'consultation.form.method.visit.label': '来校',
  'consultation.form.method.visit.desc': '東京・お台場の教室で直接ご相談いただけます。',

  // FAQSection items
  'consultation.faq.0.question': '相談は無料ですか?',
  'consultation.faq.0.answer': 'はい。個別相談は無料です。オンライン（ビデオ通話）でも来校でも承ります。',
  'consultation.faq.1.question': 'どんなことを相談できますか?',
  'consultation.faq.1.answer': 'コース選び、カリキュラムや料金の説明、キャリアのご相談、見学の手配など、何でもご相談ください。',
  'consultation.faq.2.question': '予約後の流れは?',
  'consultation.faq.2.answer': '送信後2営業日以内に、担当者より日時調整のご連絡を差し上げます。',

  // RelatedPages items
  'consultation.related.item.0.title': '入学案内概要',
  'consultation.related.item.0.desc': '入学の流れと応募資格',
  'consultation.related.item.1.title': 'コース一覧・比較',
  'consultation.related.item.1.desc': '3コースの違いを一覧で確認',
  'consultation.related.item.2.title': '体験講座',
  'consultation.related.item.2.desc': '1日で執事の所作を体験',
  'consultation.related.item.3.title': 'アクセス',
  'consultation.related.item.3.desc': '東京お台場の教室への行き方',

  // ConsultationForm
  'consultation.form.label': 'BOOKING FORM',
  'consultation.form.title': '個別相談予約フォーム',
  'consultation.form.titleEn': 'Consultation Booking',
  'consultation.form.requiredNote': 'の付いた項目は必ずご入力ください。ご希望の日時を第2希望までお知らせいただけます。',
  'consultation.form.requiredBadge': '必須',
  'consultation.form.optionalBadge': '任意',
  'consultation.form.altContact': 'フォームのほか、お電話',
  'consultation.form.altContactHours': '（平日10:00〜17:00）またはメール',
  'consultation.form.altContactSuffix': 'でもご予約を承ります。',
  'consultation.form.nameLabel': '氏名',
  'consultation.form.furiganaLabel': 'ふりがな',
  'consultation.form.emailLabel': 'メールアドレス',
  'consultation.form.phoneLabel': '電話番号',
  'consultation.form.methodLabel': '相談方法',
  'consultation.form.date1Label': '希望日時 第1希望',
  'consultation.form.date2Label': '希望日時 第2希望',
  'consultation.form.contentLabel': '相談内容',
  'consultation.form.namePlaceholder': '例: 執事 太郎',
  'consultation.form.furiganaPlaceholder': '例: しつじ たろう',
  'consultation.form.phonePlaceholder': '例: 090-1234-5678',
  'consultation.form.emailPlaceholder': '例: taro@example.com',
  'consultation.form.date1Placeholder': '例: 2026年7月10日（金）14:00〜',
  'consultation.form.date2Placeholder': '例: 2026年7月12日（日）10:00〜',
  'consultation.form.contentPlaceholder': '事前にお聞きになりたいことや、ご興味のあるコースなどがございましたら、自由にご記入ください。',
  'consultation.form.accessLink': 'アクセス案内を見る',
  'consultation.form.privacyLabel': 'に同意します',
  'consultation.form.privacyLink': 'プライバシーポリシー',
  'consultation.form.submitBtn': '確認画面へ進む',

  // Validation messages
  'consultation.form.error.name': '氏名は必須です',
  'consultation.form.error.furigana': 'ふりがなは必須です',
  'consultation.form.error.emailRequired': 'メールアドレスは必須です',
  'consultation.form.error.emailInvalid': '有効なメールアドレスを入力してください',
  'consultation.form.error.phone': '電話番号は必須です',
  'consultation.form.error.method': '相談方法をお選びください',
  'consultation.form.error.date1': '第1希望の日時は必須です',
  'consultation.form.error.content': '500文字以内で入力してください',
  'consultation.form.error.privacy': 'プライバシーポリシーへの同意が必要です',

  // PostSubmitGuide
  'consultation.post.label': 'AFTER BOOKING',
  'consultation.post.title': 'ご予約後の流れ',
  'consultation.post.titleEn': 'What to Expect',
  'consultation.post.lead': 'ご予約ありがとうございます。担当者より2営業日以内に、ご希望の日時をもとに日程調整のご連絡を差し上げます。',
  'consultation.post.step1.num': '1',
  'consultation.post.step1.title': '自動返信メール',
  'consultation.post.step1.desc': 'ご予約の受付完了をお知らせする自動返信メールをお送りします。',
  'consultation.post.step2.num': '2',
  'consultation.post.step2.title': '日程調整のご連絡',
  'consultation.post.step2.desc': '担当者より2営業日以内に、日時調整のご連絡を差し上げます。',
  'consultation.post.step3.num': '3',
  'consultation.post.step3.title': '個別相談の実施',
  'consultation.post.step3.desc': 'オンラインまたは来校にて、担当講師が個別にご相談を承ります。',
  'consultation.post.urgentNote': 'お急ぎの場合は、お電話',
  'consultation.post.urgentSuffix': '（平日10:00〜17:00）までご連絡ください。',

  // AlternativeContact
  'consultation.altContact.label': 'OTHER WAYS',
  'consultation.altContact.title': 'フォーム以外のご予約方法',
  'consultation.altContact.titleEn': 'Alternative Booking Methods',
  'consultation.altContact.lead': 'お電話またはメールでも個別相談のご予約を承ります。どうぞお気軽にお問い合わせください。',
  'consultation.altContact.phone.title': 'お電話でのご予約',
  'consultation.altContact.phone.hours': '受付時間: 平日 10:00〜17:00',
  'consultation.altContact.email.title': 'メールでのご予約',
  'consultation.altContact.email.note': 'お気軽にご連絡ください',

  // CTASection
  'consultation.cta.label': 'NEXT STEP',
  'consultation.cta.title': '申込フォームへ',
  'consultation.cta.lead': '相談不要の方は、申込フォームから直接お申込みいただけます。',
  'consultation.cta.applyBtn': '申込フォームへ',
  'consultation.cta.note': '相談前にまず体験してみたい方は、体験講座へのご参加もおすすめです。また、コースの詳細を比較されたい方は、コース一覧ページもご活用ください。',
  'consultation.cta.seminarBtn': '体験講座を見る',
  'consultation.cta.coursesBtn': 'コースを比較する',

  // FAQSection
  'consultation.faq.label': 'FAQ',
  'consultation.faq.title': 'よくあるご質問',
  'consultation.faq.titleEn': 'Frequently Asked Questions',
  'consultation.faq.contactNote': 'その他のご質問は',
  'consultation.faq.contactLink': 'お問い合わせ',
  'consultation.faq.contactSuffix': 'よりお寄せください',

  // RelatedPages
  'consultation.related.label': 'LEARN MORE',
  'consultation.related.title': '関連ページ',
  'consultation.related.titleEn': 'Explore Further',
  'consultation.related.arrowLabel': '詳しく見る',

  // footer
  'consultation.footer.lastUpdated': '最終更新: 2026年6月13日',
  'consultation.backToTop.ariaLabel': 'ページの先頭へ戻る',

  // Confirm page
  'consultation.confirm.breadcrumb.consultation': '個別相談予約',
  'consultation.confirm.breadcrumb.current': '確認',
  'consultation.confirm.title': 'ご予約内容の確認',
  'consultation.confirm.lead': '以下の内容でお間違いなければ、「送信する」をクリックしてください。',
  'consultation.confirm.privacyLabel': 'プライバシーポリシー',
  'consultation.confirm.privacyAgreed': '同意済み',
  'consultation.confirm.editBtn': '修正する',
  'consultation.confirm.submitBtn': '送信する',
  'consultation.confirm.submitting': '送信中...',
  'consultation.confirm.errorDefault': '送信に失敗しました。お手数ですが、再度お試しいただくか、お電話（03-6824-4086）にてご予約ください。',
  'consultation.confirm.errorNetwork': '通信エラーが発生しました。ネットワーク接続をご確認のうえ、再度お試しください。',
  'consultation.confirm.fields.name': '氏名',
  'consultation.confirm.fields.furigana': 'ふりがな',
  'consultation.confirm.fields.email': 'メールアドレス',
  'consultation.confirm.fields.phone': '電話番号',
  'consultation.confirm.fields.consultationMethod': '相談方法',
  'consultation.confirm.fields.preferredDate1': '希望日時 第1希望',
  'consultation.confirm.fields.preferredDate2': '希望日時 第2希望',
  'consultation.confirm.fields.content': '相談内容',
  'consultation.confirm.fields.online': 'オンライン（ビデオ通話）',
  'consultation.confirm.fields.visit': '来校',
  'consultation.confirm.fields.empty': '（未入力）',

  // Complete page
  'consultation.complete.title': 'ご予約ありがとうございます',
  'consultation.complete.p1': 'ご入力いただいたメールアドレスに、受付確認の自動返信メールをお送りしました。',
  'consultation.complete.p2': '担当者より2営業日以内に、ご希望の日時をもとに日程調整のご連絡を差し上げます。ご不明な点がございましたら、お電話（03-6824-4086・平日10:00〜17:00）にてお気軽にお問い合わせください。',
  'consultation.complete.seminarBtn': '体験講座を見る',
  'consultation.complete.homeBtn': 'トップページへ',
};

export default consultation;
